(function () {
  /**
   * Header Marquee (drag + inertia + infinite auto-scroll)
   * - Fixed-position safe (uses getBoundingClientRect instead of offsetLeft)
   * - Prevents double init
   * - Prevents runaway setTimeout timers (clears previous)
   * - Cleans hover/leave listeners (no conflicting mouseleave handlers)
   * - Avoids accidental link dragging / text selection while dragging
   *
   * IMPORTANT (CSS):
   * .slider-wrapper must be scrollable for scrollLeft to work:
   *   overflow-x: auto; overflow-y: hidden;  (and hide scrollbar if you want)
   */

  function initMarquee(slider) {
    if (!slider || slider.dataset.marqueeInit === "1") return;
    slider.dataset.marqueeInit = "1";

    const ul = slider.querySelector("ul");
    if (!ul) return;

    // Stop any previous timer if Theme Editor reloads the section
    if (slider._marqueeTimer) {
      clearTimeout(slider._marqueeTimer);
      slider._marqueeTimer = null;
    }

    // Triplica UNA sola vez (si Liquid NO duplicó)
    // Si tu Liquid ya duplica, mejor QUITA ese duplicado en Liquid.
    if (ul.children.length > 0 && !ul.dataset.tripled) {
      ul.innerHTML = ul.innerHTML + ul.innerHTML + ul.innerHTML;
      ul.dataset.tripled = "1";
    }

    // Helper: local X robusto para position:fixed / transforms
    const getLocalX = (pageX) => {
      const rect = slider.getBoundingClientRect();
      // pageX está en coordenadas de página; rect.left está en viewport.
      // Ajuste con window.scrollX para alinearlo.
      return pageX - (rect.left + window.scrollX);
    };

    // Centrar para scroll en ambas direcciones (espera layout)
    requestAnimationFrame(() => {
      const third = ul.scrollWidth / 3;
      if (third > 0) slider.scrollLeft = third;
    });

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let isPaused = false;

    let velocity = 0;
    let rafMomentum = null;
    let lastMove = 0;
    let lastTime = 0;

    const stopMomentum = () => {
      if (rafMomentum) cancelAnimationFrame(rafMomentum);
      rafMomentum = null;
    };

    const onDown = (pageX) => {
      // Only left click for mouse (ignore right click)
      isDragging = true;
      startX = getLocalX(pageX);
      startScrollLeft = slider.scrollLeft;

      slider.style.cursor = "grabbing";
      slider.classList.add("is-dragging");

      velocity = 0;
      stopMomentum();

      lastMove = pageX;
      lastTime = Date.now();
    };

    const onMove = (pageX) => {
      if (!isDragging) return;

      const now = Date.now();
      const x = getLocalX(pageX);
      const dx = x - startX;

      slider.scrollLeft = startScrollLeft - dx;

      velocity = (pageX - lastMove) / (now - lastTime + 1);
      lastMove = pageX;
      lastTime = now;
    };

    const onUp = () => {
      if (!isDragging) return;

      isDragging = false;
      slider.style.cursor = "grab";
      slider.classList.remove("is-dragging");

      // Inercia
      const momentum = () => {
        if (Math.abs(velocity) < 0.05) {
          stopMomentum();
          return;
        }
        slider.scrollLeft -= velocity * 18;
        velocity *= 0.95;
        rafMomentum = requestAnimationFrame(momentum);
      };
      momentum();
    };

    // --- Mouse events ---
    slider.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault(); // evita selección / drag de imágenes
      onDown(e.pageX);
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      onMove(e.pageX);
    });

    // mouseup en window para que no se "pegue" si sueltas fuera
    window.addEventListener("mouseup", onUp);

    // --- Touch events ---
    slider.addEventListener(
      "touchstart",
      (e) => {
        if (!e.touches || !e.touches[0]) return;
        onDown(e.touches[0].pageX);
      },
      { passive: true }
    );

    slider.addEventListener(
      "touchmove",
      (e) => {
        if (!e.touches || !e.touches[0]) return;
        onMove(e.touches[0].pageX);
      },
      { passive: true }
    );

    slider.addEventListener("touchend", onUp);

    // Pause on hover (desktop)
    slider.addEventListener("mouseenter", () => (isPaused = true));
    slider.addEventListener("mouseleave", () => {
      isPaused = false;
      onUp();
      slider.style.cursor = "grab";
    });

    // Cursor default
    slider.style.cursor = "grab";

    // Auto-scroll infinito
    function autoScroll() {
      if (!isPaused && !isDragging) {
        slider.scrollLeft += 1;

        const third = ul.scrollWidth / 3;
        if (third > 0) {
          if (slider.scrollLeft >= third * 2) slider.scrollLeft = third;
          if (slider.scrollLeft <= 0) slider.scrollLeft = third;
        }
      }
      slider._marqueeTimer = setTimeout(autoScroll, 30);
    }

    autoScroll();
  }

  function initAll(root = document) {
    root
      .querySelectorAll('.slider-wrapper[id="slider"], .slider-wrapper[id^="slider-"]')
      .forEach(initMarquee);
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document));

  // Shopify Theme Editor
  document.addEventListener("shopify:section:load", (e) => {
    if (!e.target) return;
    initAll(e.target);
  });
})();